'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Grid = require('../Grid');

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _StatsWidget = require('./StatsWidget.scss');

var _StatsWidget2 = _interopRequireDefault(_StatsWidget);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _ArrowVertical = require('../Icons/dist/components/ArrowVertical');

var _ArrowVertical2 = _interopRequireDefault(_ArrowVertical);

var _ButtonWithOptions = require('../ButtonWithOptions');

var _ButtonWithOptions2 = _interopRequireDefault(_ButtonWithOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component for app widget in Business Manager
 */
var StatsWidget = function (_WixComponent) {
  _inherits(StatsWidget, _WixComponent);

  function StatsWidget() {
    _classCallCheck(this, StatsWidget);

    return _possibleConstructorReturn(this, (StatsWidget.__proto__ || Object.getPrototypeOf(StatsWidget)).apply(this, arguments));
  }

  _createClass(StatsWidget, [{
    key: '_renderPercentage',
    value: function _renderPercentage(percent) {
      return _react2.default.createElement(
        _Text2.default,
        { appearance: 'H3' },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames4.default)(_StatsWidget2.default.percents, _defineProperty({}, _StatsWidget2.default.isNegative, percent < 0), _defineProperty({}, _StatsWidget2.default.isPositive, percent > 0)),
            'data-hook': 'percent-wrapper'
          },
          _react2.default.createElement(
            'span',
            { className: (0, _classnames4.default)(_StatsWidget2.default.percentArrow) },
            _react2.default.createElement(_ArrowVertical2.default, null)
          ),
          _react2.default.createElement(
            'span',
            { 'data-hook': 'percent-value' },
            Math.abs(percent),
            '%'
          )
        )
      );
    }
  }, {
    key: '_renderColumn',
    value: function _renderColumn(statistics, index) {
      return _react2.default.createElement(
        'div',
        { className: _StatsWidget2.default.statsColumn, key: index, 'data-hook': 'statistics-item' },
        _react2.default.createElement(
          _Text2.default,
          { dataHook: 'statistics-item-title', appearance: 'H1' },
          statistics.title
        ),
        _react2.default.createElement(
          _Text2.default,
          { dataHook: 'statistics-item-subtitle', appearance: 'H3' },
          statistics.subtitle
        ),
        typeof statistics.percent === 'number' && this._renderPercentage(statistics.percent)
      );
    }
  }, {
    key: '_renderFilters',
    value: function _renderFilters(filters) {
      return _react2.default.createElement(
        'div',
        { className: _StatsWidget2.default.filtersWrapper },
        filters
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          statistics = _props.statistics,
          children = _props.children,
          emptyState = _props.emptyState;


      return _react2.default.createElement(
        _Grid.Card,
        null,
        _react2.default.createElement(_Grid.Card.Header, {
          dataHook: 'stats-widget-title',
          title: title,
          suffix: this._renderFilters(children)
        }),
        _react2.default.createElement(
          _Grid.Card.Content,
          null,
          statistics ? _react2.default.createElement(
            'div',
            { className: _StatsWidget2.default.statsColumnWrapper, 'data-hook': 'stats-widget-content-wrapper' },
            statistics.map(function (stat, index) {
              return _this2._renderColumn(stat, index);
            })
          ) : _react2.default.createElement(
            'div',
            { 'data-hook': 'stats-widget-empty-state' },
            emptyState
          )
        )
      );
    }
  }]);

  return StatsWidget;
}(_WixComponent3.default);

StatsWidget.propTypes = {
  /** Widget title */
  title: _propTypes2.default.string.isRequired,
  /** Statistics to display */
  statistics: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    percent: _propTypes2.default.number
  })),
  /** Filters for statistics (will be shown in right top corner) Accepts array of  <StatsWidget.Filter> which accepts all dropdown properties*/
  children: _propTypes2.default.arrayOf(function (propValue, key) {
    if (!propValue || propValue.length > 3) {
      return new Error('StatsWidget: Invalid Prop children, maximum amount of filters are 3');
    }

    if (propValue[key].type !== StatsWidget.Filter) {
      return new Error('StatsWidget: Invalid Prop children, only StatsWidget.Filter is allowed');
    }
  }),
  emptyState: _propTypes2.default.node
};


StatsWidget.Filter = _ButtonWithOptions2.default;

StatsWidget.displayName = 'StatsWidget';

exports.default = StatsWidget;